<section class="journal-card">
  <h2 class="block-title">📝 Today's journal</h2>

  <textarea
    class="journal-text"
    placeholder="How was today? What went well, what didn't?"
    [value]="draftText"
    (input)="onTextInput($any($event.target).value)"
    (blur)="onTextBlur()"
    rows="4"></textarea>

  <div class="ratings">
    <div class="rating-row">
      <span class="rating-label">General</span>
      <div class="stars" (mouseleave)="hoverGeneral = 0">
        <button *ngFor="let i of [1,2,3,4,5]"
                type="button"
                class="star-btn"
                [class.filled]="starState(i) === 'filled'"
                (mouseenter)="hoverGeneral = i"
                (click)="setGeneral($any(i))"
                [attr.aria-label]="'General rating ' + i">★</button>
      </div>
    </div>

    <div class="rating-row">
      <span class="rating-label">Happiness</span>
      <div class="emoji-row" (mouseleave)="hoverHappiness = 0">
        <button *ngFor="let emoji of happinessEmojis; let i = index"
                type="button"
                class="emoji-btn"
                [class.active]="happinessState(i + 1) === 'active'"
                (mouseenter)="hoverHappiness = i + 1"
                (click)="setHappiness($any(i + 1))"
                [attr.aria-label]="'Happiness ' + (i + 1)">{{ emoji }}</button>
      </div>
    </div>
  </div>
</section>
